export default {
  label: "Gestión de Software",
  tabs: {
    myEdgeDevices: {
      label: "Mis Dispositivos Edge",
      lastConnection: "Última Conexión",
      upDateStatus: "Estado de Actualización",
      sshSession: "Sesión SSH",
      appSetSubscriptions: "Suscripciones de Conjunto de Aplicaciones",
      activities: "Actividades",
    },
    appSets: {
      label: "Conjuntos de Aplicaciones",
      appSet: "Conjunto de Aplicaciones",
      newAppset: "Nuevo Conjunto de Aplicaciones",
      apps: "Aplicaciones",
      app: "Aplicación",
      appCategory: "Categoría de Aplicación",
      deviceList: "Lista de Dispositivos",
      activities: "Actividades",
      appCategories: "Categorías de aplicaciones",
      developer: "Desarrollador",
      version: "Versión",
      releaseDate: "Fecha de Lanzamiento",
      size: "Tamaño[MB]",
      revision: "Revisión",
    },
    apps: {
      label: "Aplicaciones",
      addButton: "Agregar Aplicación",
      removeButton: "Eliminar Aplicación",
    },
    updatePropositions: {
      label: "Propuestas de Actualización",
    },
  },
};
